'use strict';

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
import modal from '../../modal';
import validator from '../../validator';
import beautyStationHelpers from './beauty-station-helpers.js';
import progress from '../../progress';

const contentInterestsErrorPopup = modal.create('#content-interests-error-popup', '#content-interests-error-popup .modal-body', {});

const initFormSubmit = function (formSelector, modalSelector) {
    var SMSsubscriptionStatus, EmailsubscriptionStatus;
    var smsFrequency, emailFrequency;

    $(".input-radio[type=radio]").change(function(){
        SMSsubscriptionStatus = $("input[name='dwfrm_beautystation_smscommunications_smsOptIn']:checked").val()
        smsFrequency = $("input[name='dwfrm_beautystation_smscommunications_smsCommunicationFrequency']:checked").val()
    })

    $('.js-configuration-preferences-container').on('submit', formSelector, function (e) {
        e.preventDefault();
        const $this = $(this);
        const submitAction = $this.find('.js-submit-btn').attr('name');
        if (submitAction === 'dwfrm_beautystation_editemailcommunications') {
            setTimeout(function () {
                EmailsubscriptionStatus = $("input[name='dwfrm_beautystation_emailcommunications_emailOptIn']:checked").val()
                emailFrequency = $("input[name='dwfrm_beautystation_emailcommunications_emailCommunicationFrequency']:checked").val() 
                window.dataLayer.push({
                    event: "emailPreferences",
                    subscriptionStatus: EmailsubscriptionStatus + "d",
                    contactFrequency:
                    EmailsubscriptionStatus === "Subscribe" ? emailFrequency : "",
                });
            }, 1000);
        }
        if (submitAction === 'dwfrm_beautystation_editsmscommunications') {
            window.dataLayer.push({
                "event": "smsPreferences",
                "subscriptionStatus": SMSsubscriptionStatus+'d',
                "contactFrequency": (SMSsubscriptionStatus === "Subscribe") ? smsFrequency : ''
            });
        }

        progress.show($this);
        $.ajax({
            url: $this.attr('action'),
            method: 'POST',
            data: $this.serialize() + '&' + submitAction,
            success: function (data) {
                progress.hide();
                //Tagging for Change Email Address(KPI 78)
                if (modalSelector === 'email-changed') {
                    window.dataLayer.push({
                        "event": "changeEmailAddress",
                    });
                }
                if (data) {
                    const $formContainer = $(`${formSelector}-container`);
                    const modalContainerSelector = `#${modalSelector}-modal-cntr`;

                    $formContainer.html(data);
                    if ($this.hasClass('communications-sms-form')) {
                        validator.initForm($('.communications-sms-form'));
                    } else if ($this.hasClass('communications-email-form')) {
                        validator.initForm($('.communications-email-form'));
                    }

                    initializeEvents();
                    $('.js-communications-form-container').foundation();

                    if ($formContainer.find(modalContainerSelector).length) {
                        const successModal = modal.create(modalContainerSelector, '.modal-body', {});
                        successModal.addCustomClass('tiny no-border');

                        if ($this.hasClass('communications-sms-form')) {
                            successModal.addAttribute('data-triggeredby', '.communications-sms-form .edit-sms');
                        } else if ($this.hasClass('communications-email-form')) {
                            successModal.addAttribute('data-triggeredby', '.communications-email-form .edit-email');
                        }

                        successModal.open();
                    }
                }
            },
            error: function () {
                location.reload();
                progress.hide();
            }
        });
    });

    $(formSelector).find('.js-submit-btn').on('click', function () {
        var validator = $(formSelector).validate();
        if (validator.numberOfInvalids()) {
            $(validator.currentForm).find('input.error:first').trigger('focus');
        }
    });

};

const myStore = function () {
    window.addEventListener('message', (event) => {
        try {
            if (event.data && event.data.indexOf('w2gi:myStoreChanged') > -1) {
                var url = window.Urls.SaveMyStore;
                var data = {
                    storeData: event.data
                };

                $.ajax({
                    url: url,
                    method: 'POST',
                    data: data
                });
            }
        }
        catch (e) {
            console.log(e.message);
        }

    }, false);
};

$(window).on('changed.zf.mediaquery', function () {
    hideContentInterestsOption();
});

const hideContentInterestsOption = function () {
    if (Foundation.MediaQuery.is('small only')) {
        $('.js-ci-boxes').hide();
        $('.content-interest-sign').text('+');
    } else {
        $('.js-ci-boxes').show();
    }
};

const toggleContentInterestsOptions = function () {
    $('.js-content-interests-title').on('click', function () {
        if (Foundation.MediaQuery.is('small only')) {
            $(this).closest('.content-interest-row').find('.js-ci-boxes').toggle();
            var contentInterestSign = $(this).find('.content-interest-sign');
            if (contentInterestSign.text() === '+') {
                contentInterestSign.text('-');
            } else {
                contentInterestSign.text('+');
            }
        }
    });
};

const toggleContentInterest = function () {
    $('.js-content-interests-form').on('change', function () {
        const data = {};
        var smsStatus = $("#communications .communications-sms-form .sms-status").text();
        const inputField = $(this).find('input');

        data.categoriesIDs = '';

        const selectedInputs = inputField.filter(':checked').toArray();

        if (selectedInputs.length > 0) {
            const selectedValues = selectedInputs.map(function (element) {
                return $(element).val();
            });
            data.categoriesIDs = selectedValues.join(',');
        }
        if (smsStatus === 'Subscribed') {
            window.dataLayer.push({
                "event": "smsContentInterests",
                "contentInterests": data.categoriesIDs
            });
        }

        const csrfToken = $(this).find('.csrf-token');
        data[csrfToken.attr('name')] = csrfToken.val();
        data.format = 'ajax';

        $.ajax({
            url: this.action,
            method: 'POST',
            data: data
        }).done(function (data) {
            if (!data.success) {
                contentInterestsErrorPopup.$cntr.find('.modal-description').empty().text(data.error);
                contentInterestsErrorPopup.open();
            }
        }).fail(function () {
            contentInterestsErrorPopup.$cntr.find('.modal-description').empty().text(Resources.AJAX_FAIL_ERROR);
            contentInterestsErrorPopup.open();
        });
    });
};

const initializeEvents = function () {
    beautyStationHelpers.togglePasswordVisibility();
    beautyStationHelpers.validatePassword();
    myStore();
    $(document).on('open.zf.reveal', '#SampleSmsModal, #SampleEmailModal', function (e) {
        $(this).parent('.reveal-overlay').addClass('scrollable');
    });

    $(document).on('closed.zf.reveal', '#SampleSmsModal, #SampleEmailModal', function (e) {
        $(this).parent('.reveal-overlay').removeClass('scrollable');
    });

    $('.communications-language-selector-form').find('.js-submit-btn').on('click', function () {
        var validator = $('.communications-language-selector-form').validate();
        if (validator.numberOfInvalids()) {
            $(validator.currentForm).find('select.error:first').trigger('focus');
        }
    });

};

const emailSmsOptIn = function () {
    $(document).on("click", '.js-communications-form .edit-email', function (e) {
        e.preventDefault();
        $(".communications-email-form").find('.visible-block').removeClass('hidden-block').find(':tabbable').first().trigger('focus');
        $(this).hide();
        showHideFrequency($(this).closest('form'), 'edit');
    });

    $(document).on("click", '.js-communications-form .edit-sms', function (e) {
        e.preventDefault();
        $(".communications-sms-form").find('.visible-block').removeClass('hidden-block').find(':tabbable').first().trigger('focus');
        $(this).hide();
        showHideFrequency($(this).closest('form'), 'edit');
    });

    $(document).on("click", '.js-communications-form .cancel-email', function (e) {
        e.preventDefault();
        $(".communications-email-form").find('.visible-block').addClass('hidden-block');
        $('.edit-email').show().trigger('focus');
        showHideFrequency($(this).closest('form'), 'cancel');
    });

    $(document).on("click", '.js-communications-form .cancel-sms', function (e) {
        e.preventDefault();
        $(".communications-sms-form").find('.visible-block').addClass('hidden-block');
        $('.edit-sms').show().trigger('focus');
        showHideFrequency($(this).closest('form'), 'cancel');
    });


    //Hide frequency selection for UNSubscribe
    $(document).on("change", 'input[name=dwfrm_beautystation_smscommunications_smsOptIn], input[name=dwfrm_beautystation_emailcommunications_emailOptIn]', function (e) {
        if ($(this).val() === 'Subscribe') {
            $(this).closest('form').find('.frequency_statusBlock').show();
            $(this).closest('form').find('.frequency_selectionBlock').slideDown();
        } else {
            $(this).closest('form').find('.frequency_statusBlock').hide();
            $(this).closest('form').find('.frequency_selectionBlock').slideUp();
        }
    });
};

function showHideFrequency($form, actionType) {
    var isSubscribed;
    if (actionType == 'cancel') {
        isSubscribed = $($form).find('.subscription_statusBlock span').data('status');
    } else {
        isSubscribed = ($($form).find('.subscription_selectionBlock input[type="radio"]:checked').val() === 'Subscribe');
    }
    if (isSubscribed) {
        $($form).find('.frequency_statusBlock, .frequency_selectionBlock').slideDown(200);
    } else {
        $($form).find('.frequency_statusBlock, .frequency_selectionBlock').slideUp(200);
    }
}

const configurationPreferences = {
    init: function () {
        if ($('.js-configuration-preferences-container').length === 0) {
            return;
        }

        initializeEvents();
        initFormSubmit('.js-change-email-form', 'email-changed');
        initFormSubmit('.js-change-password-form', 'password-changed');
        initFormSubmit('.js-communications-form', 'communications-updated');
        hideContentInterestsOption();
        toggleContentInterestsOptions();
        toggleContentInterest();
        emailSmsOptIn();
    }
}

export default configurationPreferences;